import { DataTexture, DoubleSide, ShaderMaterial, UniformsLib, UniformsUtils, Vector2 } from "three"
import type { Engine } from "../../../../core/engine/Engine.type"
import { getEngineThreeMainCamera } from "../../../fn/getSetEngineThreeMainCamera"
import { getEngineThreeMainRenderer } from "../../../fn/getSetEngineThreeMainRenderer"
import { waterPlaneV7ToonWaterFragmentShader, waterPlaneV7ToonWaterVertexShader } from "./ToonWaterShader/waterPlaneV7ToonWaterShaders"

export default function createWaterPlaneV7ToonWaterMaterial(
  engine: Engine,
): ShaderMaterial {
  const renderer = getEngineThreeMainRenderer(engine)
  const camera = getEngineThreeMainCamera(engine)

  const sceneTexture = new DataTexture(new Uint8Array([255, 255, 255, 255]), 1, 1)
  sceneTexture.needsUpdate = true

  const depthTexture = new DataTexture(new Uint8Array([255, 255, 255, 255]), 1, 1)
  depthTexture.needsUpdate = true

  const width = renderer.domElement.width || 1
  const height = renderer.domElement.height || 1

  const uniforms = UniformsUtils.merge([
    UniformsLib.lights,
    {
      u_sceneTexture: { value: sceneTexture },
      u_depthTexture: { value: depthTexture },
      u_normalTexture: { value: null },
      u_winRes: { value: new Vector2(width, height) },
      u_near: { value: camera.near },
      u_far: { value: camera.far },
      u_time: { value: 0 },
      u_absorbStrength: { value: 2.0 },
      u_stepped: { value: false },
      u_shine: { value: 150.0 },
      u_diffuse: { value: 0.1 },
      u_minBrightness: { value: 0.2 },
    },
  ])

  const material = new ShaderMaterial({
    name: "WaterPlaneV7ToonWater",
    uniforms,
    vertexShader: waterPlaneV7ToonWaterVertexShader,
    fragmentShader: waterPlaneV7ToonWaterFragmentShader,
    lights: true,
    side: DoubleSide,
    transparent: true,
  })

  return material
}